import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-container">
      <section className="hero-section">
        <div className="hero-content">
          <h1>Unlock Your Golf Potential</h1>
          <h2>Launch Monitor Data Analysis Made Simple</h2>
          <p>
            RangeDat is a launch-monitor agnostic tool that allows golfers to upload 
            launch monitor data for analysis, visualization, and receive AI driven insights.
          </p>
          <div className="hero-buttons">
            <button onClick={() => navigate('/signup')} className="btn-primary">Get Started</button>
            <button onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })} className="btn-secondary">Learn More</button>
          </div>
        </div>
        <div className="hero-image">
          <div className="image-placeholder">
            {/* Golf swing or launch monitor image would go here */}
            <div className="placeholder-text">Golf Swing Analysis</div>
          </div>
        </div>
      </section>

      <section id="features" className="features-section">
        <h2>Why Choose RangeDat?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Universal Compatibility</h3>
            <p>Works with data from all major launch monitors including Trackman, GCQuad, Flightscope, and more.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔍</div>
            <h3>Advanced Analytics</h3>
            <p>Visualize your performance trends and identify areas for improvement with detailed statistics.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🤖</div>
            <h3>AI-Powered Insights</h3>
            <p>Receive personalized recommendations and swing analysis from our advanced AI engine.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>Access Anywhere</h3>
            <p>Cloud-based platform accessible from any device, whether you're at the range or at home.</p>
          </div>
        </div>
      </section>

      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Upload Your Data</h3>
            <p>Simply upload your launch monitor data files in CSV, JSON, or other supported formats.</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Analyze Performance</h3>
            <p>Our system processes your data and generates comprehensive performance metrics.</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Get Insights</h3>
            <p>Receive AI-driven recommendations to improve your game based on your specific data.</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h3>Track Progress</h3>
            <p>Monitor your improvement over time with detailed trend analysis and progress reports.</p>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <h2>What Golfers Are Saying</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <div className="testimonial-text">
              "RangeDat has completely transformed how I practice. The insights from my launch monitor data have helped me lower my handicap by 3 strokes in just two months!"
            </div>
            <div className="testimonial-author">- Michael T., Handicap 8</div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-text">
              "As a teaching professional, I recommend RangeDat to all my students. It helps them understand their swing data and track improvements between lessons."
            </div>
            <div className="testimonial-author">- Sarah L., PGA Teaching Pro</div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-text">
              "I use multiple launch monitors at different facilities. RangeDat is the only tool that lets me consolidate all my data in one place for consistent analysis."
            </div>
            <div className="testimonial-author">- James R., Collegiate Golfer</div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Elevate Your Golf Game?</h2>
        <p>Join thousands of golfers who are using data to drive improvement.</p>
        <button onClick={() => navigate('/signup')} className="btn-primary btn-large">Start Your Free Trial</button>
      </section>

      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-logo">
            <h2>RangeDat</h2>
            <p>Launch Monitor Data Analysis</p>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h3>Product</h3>
              <ul>
                <li>Features</li>
                <li>Pricing</li>
                <li>Testimonials</li>
                <li>FAQ</li>
              </ul>
            </div>
            <div className="footer-column">
              <h3>Company</h3>
              <ul>
                <li>About Us</li>
                <li>Contact</li>
                <li>Privacy Policy</li>
                <li>Terms of Service</li>
              </ul>
            </div>
            <div className="footer-column">
              <h3>Resources</h3>
              <ul>
                <li>Blog</li>
                <li>Support</li>
                <li>Tutorials</li>
                <li>Partners</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} RangeDat. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
